export default __webpack_public_path__ + "static/media/logo_light_bg.6c5c3b5b.svg";